import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import SelectGroup from 'components/vendor-requests/shared/SelectGroup';
import styled from 'styled-components';
import { PlainButton } from 'components/styled-components';
import { InputGroup, TextArea } from '@blueprintjs/core';
import { NavLink } from 'react-router-dom';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';
import * as actions from 'actions/vendor-request';
import FormCreatableGroup from 'components/forms/components/form-createable-group';

const mapProductServiceName = psn => {
  if (typeof psn === 'string') {
    return { vendorID: psn, productServiceName: psn };
  } else {
    return psn;
  }
};

const VendorInfoBase = props => {
  const { editing, appUser, setFieldValue, values } = props;

  useEffect(() => {
    if (!!props.request.vendorInformation) {
      props.fetchVendorContacts(props.request.vendorInformation.vendorName);
      props.fetchVendorProducts(props.request.vendorInformation.vendorID);
    }

    if (!!!props.vendors.length) {
      props.fetchAllVendors();
    }
  }, []);

  const handleUpdateVendorInformation = (_, selected) => {
    setFieldValue('vendorInformation', selected);
    props.fetchVendorProducts(selected.vendorID);

    if (values.vendorInformation.vendorID !== selected.vendorID) {
      setFieldValue('vendorContact', null);
      setFieldValue('productServiceName', null);
      props.fetchVendorContacts(selected.vendorName);
      props.fetchVendorProducts(selected.vendorID);
    }
  };

  return (
    <DataWrapper>
      <div>
        <MutedLabel>Third Party Name</MutedLabel>
        {editing ? (
          <SelectGroup
            value={values.vendorInformation}
            options={props.vendors}
            getOptionLabel={option => option.vendorName}
            getOptionValue={option => option.vendorID}
            customClass="margin-select"
            changeHandler={handleUpdateVendorInformation}
            name="vendorInformation"
          />
        ) : (
          <H1>
            {props.request.vendorInformation &&
              props.request.vendorInformation.vendorName}
          </H1>
        )}
      </div>
      <div>
        <MutedLabel>Product or Service</MutedLabel>
        {editing ? (
          <FormCreatableGroup
            name="productServiceName"
            value={values && mapProductServiceName(values.productServiceName)}
            asyncOptions={props.products}
            onChange={props.setFieldValue}
            labelKey="productServiceName"
            valueKey="productServiceName"
            onBlur={props.setFieldTouched}
          />
        ) : (
          <H1>{props.request.productServiceName}</H1>
        )}
      </div>
      <div>
        <MutedLabel>Third Party Contact</MutedLabel>
        {editing ? (
          <SelectGroup
            value={values.vendorContact}
            options={props.contacts}
            getOptionLabel={option => `${option.firstName} ${option.lastName}`}
            getOptionValue={option => option.userID}
            customClass="margin-select"
			isMulti={true}
            changeHandler={props.setFieldValue}
            name="vendorContact"
          />
        ) : (
          <H1>
            {props.request.vendorContact && props.request.vendorContact.length > 0 ?
				props.request.vendorContact.map(vc => {
					let firstName = typeof vc.firstName !== 'undefined' && vc.firstName !== null ? vc.firstName : "No First Name";
					let lastName = typeof vc.lastName !== 'undefined' && vc.lastName !== null ? vc.lastName : "No Last Name";
					return `${firstName} ${lastName}`;
				}).join('; ')
			: ""}
          </H1>
        )}
      </div>
      <div>
        <MutedLabel>Contact Email</MutedLabel>
        {editing ? (
          <TextArea
            value={values.vendorContact && values.vendorContact.length > 0 ?
				values.vendorContact.map(vc => {
					let email = typeof vc.email !== 'undefined' && vc.email !== null ? vc.email : "";
					return `${email}`;
				}).join('; ')
			: ""}
            disabled={true}
            className="margin-select"
			style={{width: "100%", "color": "#FFFFFF"}}
            large
          />
        ) : (
          <H1>
			{props.request.vendorContact && props.request.vendorContact.length > 0 ?
				props.request.vendorContact.map(vc => {
					let email = typeof vc.email !== 'undefined' && vc.email !== null ? vc.email : "";
					return `${email}`;
				}).join('; ')
			: ""}
          </H1>
        )}
      </div>
      {hasPermission(appUser.permissions, permissions.VIEW_THIRD_PARTY) && (
        <ButtonWrapper>
          <NavLink to={`/manage-parties/${props.vendorID}`}>
            <PlainButton>View third party profile</PlainButton>
          </NavLink>
        </ButtonWrapper>
      )}
      {hasPermission(
        appUser.permissions,
        permissions.MODIFY_ANY_QUESTIONNAIRE
      ) && (
        <ButtonWrapper>
          <NavLink to={`/questionnaire/${props.request.vendorRequestID}`}>
            <PlainButton>Go to Questionnaire</PlainButton>
          </NavLink>
        </ButtonWrapper>
      )}
      {props.request.requestStatus === 'Awaiting Third Party Completion' &&
        hasPermission(
          appUser.permissions,
          permissions.MODIFY_QUESTIONNAIRE
        ) && (
          <ButtonWrapper>
            <NavLink to={`/questionnaire/${props.request.vendorRequestID}`}>
              <PlainButton>Go to Questionnaire</PlainButton>
            </NavLink>
          </ButtonWrapper>
        )}
    </DataWrapper>
  );
};

const DataWrapper = styled.div`
  padding: 1.5rem 0;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  flex-basis: 50%;
  min-width: 19rem;
`;

const MutedLabel = styled.span`
  font-weight: 300;
  font-size: 0.8rem;
  margin: 1rem 0 0.5rem;
`;

const H1 = styled.h1`
  font-weight: 300;
  font-size: 1.5rem;
`;

const ButtonWrapper = styled.div`
  margin: 2rem 0 0 -1rem;
`;

const mapStateToProps = state => ({
  vendors: state.vendorRequest.vendors,
  contacts: state.vendorRequest.contacts,
  products: state.vendorRequest.products,
});

const VendorInfo = connect(
  mapStateToProps,
  {
    ...actions,
  }
)(VendorInfoBase);

export default VendorInfo;
